export class AppEnv {
	public static readonly STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY || 'key';

	public static readonly BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:5156/';

	public static readonly HOST = process.env.REACT_APP_HOST || 'http://localhost:3000/';
}
